const PAUSABLE_TIMER_STATES = {
    EMPTY: '',
    PAUSED: 'paused',
    COUNTING: 'counting',
};

export class PausableTimer {
    private _timerId: number;
    private _remainingTime: number;
    private _startTime: number;
    private _callback: Function;
    private _state: string = PAUSABLE_TIMER_STATES.EMPTY;

    constructor(callback: Function, delay: number) {
        this._remainingTime = delay;
        this._callback = callback;
        this.resume();
    }

    public pause() {
        if (this._state !== PAUSABLE_TIMER_STATES.PAUSED) {
            let timeElapsed = Date.now() - this._startTime;
            
            this._state = PAUSABLE_TIMER_STATES.PAUSED;
            this._clearTimer();
            this._remainingTime = this._remainingTime - timeElapsed;
        }
    }

    public resume() {
        if (this._state !== PAUSABLE_TIMER_STATES.COUNTING) {
            this._state = PAUSABLE_TIMER_STATES.COUNTING;
            this._clearTimer();
            this._startTime = Date.now();
            this._timerId = setTimeout(this._callback, this._remainingTime);
        }
    }

    public destroy() {
        this._clearTimer();
        this._timerId = null;
    }

    private _clearTimer() {
        if (this._timerId) {
            clearTimeout(this._timerId);
        }
    }
}